import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem("for_user");
    return u ? JSON.parse(u) : null;
  });
  const [loading, setLoading] = useState(false);

  const persist = (token, u) => {
    localStorage.setItem("for_token", token);
    localStorage.setItem("for_user", JSON.stringify(u));
    setUser(u);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    persist(data.token, data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    persist(data.token, data.user);
    return data.user;
  };

  const sendLoginCode = async (email) => {
    await api.post("/auth/send-code", { email });
  };

  const loginWithCode = async (email, code) => {
    const { data } = await api.post("/auth/login-code", { email, code });
    persist(data.token, data.user);
    return data;
  };

  const loginWithMagic = async (token) => {
    const { data } = await api.post("/auth/magic-login", { token });
    persist(data.token, data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("for_token");
    localStorage.removeItem("for_user");
    setUser(null);
  };

  const updateUser = (patch) => {
    setUser((prev) => {
      const next = { ...(prev || {}), ...patch };
      localStorage.setItem("for_user", JSON.stringify(next));
      return next;
    });
  };

  useEffect(() => {
    const token = localStorage.getItem("for_token");
    if (token && !user) {
      api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => {});
    }
    // eslint-disable-next-line
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, register, sendLoginCode, loginWithCode, loginWithMagic, logout, updateUser, loading, setLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
